import axios from "axios";
import React, { useContext } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { UserContext } from "./UserContext";

const Login = () => {
  const history = useHistory();
  const [, setUser] = useContext(UserContext);
  const Auth = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    const email = data.get("email");
    const password = data.get("password");
    try {
      const { data } = await axios.post(
        "https://salt-neobank.herokuapp.com/login",
        {
          email: email,
          password: password,
        }
      );
      setUser(data);
      history.push(`/${data.role}/home`);
    } catch (err) {
      alert(err.response.data.error);
    }
  };
  return (
    <Container>
      <h1>Welcome To NeoBank</h1>
      <LoginForm onSubmit={(e) => Auth(e)}>
        <label htmlFor="email">Email</label>
        <input type="email" name="email" id="email" />
        <label htmlFor="password">Password</label>
        <input type="password" name="password" id="password" />
        <button type="submit">Login</button>
      </LoginForm>
    </Container>
  );
};
const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  & > * {
    margin: 0.5em 0;
  }
  input {
    padding: 0.5em;
    border: none;
    border-radius: 4px;
    :focus {
      outline: none;
      border: 1px solid #f5642f;
    }
  }
  button {
    border-radius: 4px;
    padding: 0.5em;
    border: none;
    background-color: #f5642f;
    color: white;
    font-size: 1.1rem;
    cursor: pointer;
  }
`;
const Container = styled.div``;
export default Login;
